import { styles } from './template.scss';
import { styles as commonStyles } from '../../../assets/common.scss';
import { styles as widgetSharedStyles } from '../../../assets/widget-shared.scss';
import { styles as colorHelpersStyles } from '../../../assets/color-helpers.scss';
import { styles as flexboxHelpersStyles } from '../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../assets/text-helpers.scss';

export const templateUploadWindow = document.createElement('template');

templateUploadWindow.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpers}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class="wrapper d-flex flex-column">
    <gz-text id="title" class="pb-4" fontSize="14"></gz-text>
    <div>
      <gz-form-field label="" id="upload-path-field" stacked>
        <gz-input gz-form-input id="upload-path-input"  type="text" placeholder="" inputwidth='400'></gz-input>
        <gz-input-error></gz-input-error>
      </gz-form-field>
      <gz-form-field class="pt-3" label="" id="select-files-field" stacked>
        <gz-text id="select-files-description" class="pb-1" fontSize="12"></gz-text>
        <gz-file-input multiple=true gz-form-input type="quiet" color="secondary" id="files-input">
            <gz-button
              id="browse-button"
              browse-button
              type='full'
              color= 'primary'
              buttonHeight='medium'
              buttonFontSize='medium'
            >
            </gz-button>
        </gz-file-input>
        <gz-input-error></gz-input-error>
      </gz-form-field>
      <div class="mt-7 d-flex flex-column">
        <div id="files-number-title-container" class="d-inline files-title-container">
          <gz-title id='files-number-title' class="files-title d-inline" fontSize="11"></gz-title>
          <gz-title id="files-number" class="d-inline file-size" fontSize="11"></gz-title>
        </div>
        <div id="files-title-container" class="d-inline files-title-container">
          <gz-title id='files-title' class="files-title d-inline" fontSize="11"></gz-title>
          <gz-title id="files-size" class="d-inline file-size" fontSize="11"></gz-title>
        </div>
        <div id="files-list" class="pt-1"></div>
      </div>
    </div>
  </div>
`;
